import { useContext } from 'react'
import { DiscoverContext } from '../context/DiscoverContext'

export const useDiscover = () => {
  const context = useContext(DiscoverContext)
  if (!context)
    throw new Error('useDiscover must be used within DiscoverContextProvider')
  return context
}
